export default {
  selected: new Set(),
  selectedInfo: new Map()
}
